export function fetchPaymentsAction(organizationId, residentId) {
  return dispatch => {
    $.ajax({
      url: `/organizations/${organizationId}/residents/${residentId}/payments.json`
    }).then((payments) => {
      dispatch(fetchPaymentsResponseAction(payments))
    })
  }
}

export function fetchPaymentsResponseAction(payload) {
  return { type: 'FETCH_PAYMENTS_RESPONSE', payload }
}

export function fetchPaymentTotalsAction(organizationId, residentId) {
  return dispatch => {
    $.ajax({
      url: `/organizations/${organizationId}/residents/${residentId}/payments/totals.json`
    }).then((totals) => {
      dispatch(fetchPaymentTotalsResponseAction(totals))
    })
  }
}

export function fetchPaymentTotalsResponseAction(payload) {
  return { type: 'FETCH_PAYMENT_TOTALS_RESPONSE', payload }
}

export function createPaymentAction(organizationId, residentId, payment) {
  return dispatch => {
    return $.ajax({
      url: `/organizations/${organizationId}/residents/${residentId}/payments.json`,
      method: 'POST',
      data: { payment }
    }).then(() => {
      dispatch(fetchPaymentsAction(organizationId, residentId))
      dispatch(fetchPaymentTotalsAction(organizationId, residentId))
    })
  }
}

export function updatePaymentAction(organizationId, residentId, payment) {
  return dispatch => {
    $.ajax({
      url: `/organizations/${organizationId}/residents/${residentId}/payments/${payment.id}.json`,
      method: 'PATCH',
      data: { payment }
    }).then(() => {
      dispatch(updatePaymentResponseAction())
      dispatch(fetchPaymentTotalsAction(organizationId, residentId))
      dispatch(fetchPaymentsAction(organizationId, residentId))
    })
  }
}

export function updatePaymentResponseAction() {
  return { type: 'UPDATE_PAYMENT_RESPONSE' }
}

export function deletePaymentAction(organizationId, residentId, paymentId) {
  return dispatch => {
    $.ajax({
      url: `/organizations/${organizationId}/residents/${residentId}/payments/${paymentId}.json`,
      method: 'DELETE'
    }).then(() => {
      dispatch(deletePaymentResponseAction(paymentId))
      dispatch(fetchPaymentsAction(organizationId, residentId))
      dispatch(fetchPaymentTotalsAction(organizationId, residentId))
    })
  }
}

export function deletePaymentResponseAction(payload) {
  return { type: 'DELETE_PAYMENT_RESPONSE', payload }
}
